import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-009be1ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ATagToRoute = _resolveComponent("ATagToRoute")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (a) => {
      return (_openBlock(), _createElementBlock("div", {
        key: a.id,
        class: "alert-item"
      }, [
        _createVNode(_component_ATagToRoute, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: a.message
            }, null, 8, _hoisted_1)
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128))
  ]))
}